(ns ui.cofx.account
  (:require
   [re-frame.core :as rf]
   [frontend.state.current-session :as session]))

(defn favorite-single-entity-views-cofx
  [cofx _]
  (assoc cofx :favorite-single-entity-views
         (get-in @session/account [:account/preferences :favorite-single-entity-views] {})))

(rf/reg-cofx
 ::favorite-single-entity-views
 favorite-single-entity-views-cofx)
